import PropTypes from "prop-types";
import { StyledTag } from "../../styles/StyledTag";

export default function Tag({ children }) {
	return <StyledTag>{children}</StyledTag>;
}

Tag.propTypes = {
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
